module.exports = __webpack_public_path__ + "static/media/4dp.24d3b159.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/4dp.jpg
// module id = 273
// module chunks = 2